import { createSlice } from "@reduxjs/toolkit"
import { showGlobalModal, hideGlobalModalEffect } from "./actions"

type RunlevelSliceState = {
    globalModal: boolean
}

const initialState = {
    globalModal: false,
} as RunlevelSliceState

const slice = createSlice({
    name: "runlevel",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(showGlobalModal, (state) => {
                state.globalModal = true
            })
            .addCase(hideGlobalModalEffect, (state) => {
                state.globalModal = false
            })
    },
})

export default slice.reducer
